import React, { useState } from 'react';
import './GoogleDriveHelp.css';

const GoogleDriveHelp = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="google-drive-help">
     

      {isOpen && (
        <div className="help-content">
          <div className="help-header">
            <h4>📁 Import d'images depuis Google Drive</h4>
            <button 
              className="close-btn"
              onClick={() => setIsOpen(false)}
              type="button"
            >
              ×
            </button>
          </div>

          <div className="help-body">
            <div className="help-section">
              <h5>🔗 Formats de liens supportés :</h5>
              <ul>
                <li><code>https://drive.google.com/file/d/FILE_ID/view?usp=sharing</code></li>
                <li><code>https://drive.google.com/open?id=FILE_ID</code></li>
                <li><code>FILE_ID</code> (juste l'ID du fichier)</li>
              </ul>
            </div>

            <div className="help-section">
              <h5>📋 Colonnes Excel pour les images :</h5>
              <ul>
                <li><strong>Colonne Y</strong> : URL de l'image principale</li>
                <li><strong>Colonne Z</strong> : URL image 2 (Google Drive)</li>
                <li><strong>Colonne AA</strong> : URL image 3 (Google Drive)</li>
                <li><strong>Colonne AB</strong> : URL image 4 (Google Drive)</li>
              </ul>
            </div>

            <div className="help-section">
              <h5>⚙️ Comment partager un fichier Google Drive :</h5>
              <ol>
                <li>Ouvrez Google Drive et sélectionnez votre image</li>
                <li>Clic droit → "Partager" ou icône de partage</li>
                <li>Changez l'accès à <strong>"Tous les utilisateurs avec le lien"</strong></li>
                <li>Sélectionnez <strong>"Lecteur"</strong> comme rôle</li>
                <li>Cliquez sur "Copier le lien"</li>
                <li>Collez ce lien dans votre fichier Excel</li>
              </ol>
            </div>

            <div className="help-section">
              <h5>✅ Formats d'images supportés :</h5>
              <ul>
                <li>JPG / JPEG</li>
                <li>PNG</li>
                <li>GIF</li>
                <li>WEBP</li>
              </ul>
            </div>

            <div className="help-section">
              <h5>⚠️ Important :</h5>
              <ul>
                <li>Les fichiers doivent être <strong>publics</strong> (partage avec lien)</li>
                <li>Maximum 4 images par produit</li>
                <li>Les images sont téléchargées automatiquement lors de l'import</li>
                <li>Taille recommandée : moins de 5MB par image</li>
              </ul>
            </div>

            <div className="help-section example">
              <h5>📝 Exemple d'utilisation :</h5>
              <div className="example-table">
                <table>
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>SKU</th>
                      <th>...</th>
                      <th>Image 1 (Y)</th>
                      <th>Image 2 (Z)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Produit A</td>
                      <td>SKU001</td>
                      <td>...</td>
                      <td>https://drive.google.com/file/d/1ABC.../view</td>
                      <td>https://drive.google.com/file/d/1DEF.../view</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoogleDriveHelp;
